import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SaleFormula, SaleFormulaDetail } from "../model/sale-formula.model";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { FormGroup } from "@angular/forms";
import { take } from "rxjs/operators";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { AppInjector } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { SaleItemListComponent } from "./sale-item-list/sale-item-list.component";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";

@Component({
  selector: "ngx-sale-formula",
  templateUrl: "./sale-formula.component.html",
  styleUrls: ["./sale-formula.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleFormulaComponent extends BaseFormComponent<SaleFormula> {
  @ViewChild("grid") headerGrid: KGridComponent;
  public headerColumns: form_control[] = [];
  detailsColumns: form_control[] = [];
  headersColumns: form_control[] = [];
  selectedRow: SaleFormula;
  formulas: SaleFormula[] = [];
  itemId: number;
  itemTitle: string;
  addGoods: boolean = false;
  erroremessage: string;
  haserror: boolean;

  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    _VoucherKIndInfo: VoucherKindInfo,
    __id: FormContainerModel
  ) {
    super(selectorService, cd);
    this.tabsservice = AppInjector.get(TabularService);
    if (_VoucherKIndInfo["formulas"]) this.formulas = _VoucherKIndInfo["formulas"];
    if (_VoucherKIndInfo["ItemId"]) this.itemId = _VoucherKIndInfo["ItemId"];
    if (_VoucherKIndInfo["itemTitle"]) this.itemTitle = _VoucherKIndInfo["itemTitle"];
    this._id = __id;
  }
  async ngOnInit() {
    this.apiName = "SaleFormula";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ComponentsOfGoods");
    super.ngOnInit();
    this.setHeaderColumns();
    this.setDetailColumns();
    if (this.formulas?.length) this.selectedRow = this.formulas[0];
  }

  setHeaderColumns() {
    this.headersColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Goods"),
      controlType: FormControlTypes.textbox,
      modelName: "ItemId",
      textType: "number",
      disabled: false,
      name: "ItemId",
      order: 0,
      formVisible: false,
      listVisible: false,
      required: true,
    });
    this.headersColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.EffectiveDate"),
      controlType: FormControlTypes.datePicker,
      modelName: "EffectDate",
      disabled: false,
      name: "EffectDate",
      textType: "date",
      order: 7,
      userClass: "effect-date",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headersColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Branch"),
      controlType: FormControlTypes.dropdown,
      modelName: "BranchId",
      disabled: false,
      name: "BranchId",
      textType: "text",
      order: 8,
      formVisible: true,
      listVisible: true,
      required: false,
      apiName: "Branch/ReadLookUp",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.headersColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.AnalysisItems"),
      controlType: FormControlTypes.dropdown,
      modelName: "SaleFormulaDetails",
      disabled: false,
      name: "SaleFormulaDetails",
      textType: "text",
      order: 10,
      formVisible: false,
      listVisible: false,
      required: false,
    });
  }
  setDetailColumns() {
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Formula"),
      controlType: FormControlTypes.textbox,
      modelName: "SaleFormulaId",
      textType: "number",
      disabled: true,
      name: "SaleFormulaId",
      order: 0,
      formVisible: false,
      listVisible: false,
      required: false,
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ItemCode"),
      controlType: FormControlTypes.textbox,
      modelName: "GoodsCode",
      disabled: true,
      name: "GoodsCode",
      textType: "text",
      order: 1,
      formVisible: false,
      listVisible: true,
      required: false,
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Goods"),
      controlType: FormControlTypes.lookup,
      modelName: "GoodsId",
      textType: "text",
      disabled: false,
      name: "GoodsId",
      order: 2,
      formVisible: false,
      listVisible: true,
      required: true,
      apiName: "SaleFormula/GetAnalysisGoodsPaging",
      valueMember: "Id",
      displayMember: "Title",
      columnsName: "Code,Title,UnitTitle,GoodsKindTitle",
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ItemTitle"),
      controlType: FormControlTypes.textbox,
      modelName: "GoodsTitle",
      disabled: true,
      name: "GoodsTitle",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: false,
      required: false,
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ProductTypeCode"),
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindCode",
      disabled: true,
      name: "GoodsKindCode",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: false,
      required: false,
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.Amount"),
      controlType: FormControlTypes.textbox,
      modelName: "Amount",
      textType: "number",
      min: 0.00001,
      max: 999999999999,
      disabled: false,
      name: "Amount",
      order: 5,
      tabOrder: 5,
      formVisible: true,
      listVisible: true,
      required: true,
      isFloat: null,
      isDecimal: true,
      withComma: true,
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.MeasurementUnit"),
      controlType: FormControlTypes.textbox,
      modelName: "GoodsUnitTitle",
      textType: "text",
      disabled: true,
      name: "GoodsUnitTitle",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailsColumns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ProductTypeTitle"),
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindTitle",
      disabled: true,
      name: "GoodsKindTitle",
      textType: "text",
      order: 3,
      formVisible: false,
      listVisible: true,
      required: false,
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onDetailRowChanges(changedData: { newValue: SaleFormulaDetail; oldValue: SaleFormulaDetail; field: string; formGroup: FormGroup }) {
    if (!changedData.formGroup.value.SaleFormulaId) changedData.formGroup.controls["SaleFormulaId"].setValue(0);
  }

  onHeaderChanges(group: FormGroup) {
    this.showHideActions();
    if (group && group.controls) {
      if (!group?.value.SaleFormulaDetails) group.controls["SaleFormulaDetails"].setValue([]);
      if (!group?.value.ItemId) group.controls["ItemId"].setValue(this.itemId);
      this.selectedRow = group?.getRawValue();
    }
  }

  onLookupChanges(change: { event: any; key: string; valueMember: string; displayMember: string; dataItem: any; formGroup: FormGroup }) {
    if (change.key === "GoodsId") {
      change.dataItem.GoodsKindTitle = change.event?.GoodsKindTitle;
      change.dataItem.GoodsKindCode = change.event?.GoodsKindCode;
      change.dataItem.GoodsUnitTitle = change.event?.GoodsUnitTitle;
      change.formGroup.controls["GoodsKindTitle"].setValue(change.event?.GoodsKindTitle);
      change.formGroup.controls["GoodsKindCode"].setValue(change.event?.GoodsKindCode);
      change.formGroup.controls["GoodsUnitTitle"].setValue(change.event?.GoodsUnitTitle);
    }
  }

  public openGoodsForm() {
    let menu = <ITab>{
      title: this.translate("ClientApp.FrontOffice.Inv.SaleFormula.ItemList"),
      isCloseable: true,
      active: true,
      responsive: true,
      data: [],
      componentType: SaleItemListComponent,
      hasbadge: false,
    };
    this.tabsservice.open(menu);
  }

  setdefault(): void {
    this.showHideActions();
  }

  isValid(): boolean {
    this.erroremessage = undefined;
    this.haserror = false;
    if (!this.formulas.length) {
      this.haserror = true;
      this.sts.showToast("warning", "", this.translate("ClientApp.FrontOffice.Inv.SaleFormula.EnterAtLeastOneAnalysis"), 3500);
    }
    if (this.formulas.some((x) => x.State !== RowState.Delete && x.SaleFormulaDetails.filter((z) => z.State !== RowState.Delete).length === 0)) {
      this.haserror = true;
      this.sts.showToast("warning", "", this.translate("ClientApp.FrontOffice.Inv.SaleFormula.EnterAtLeastOneIngredient"), 3500);
    }
    return !this.haserror;
  }

  public async save(): Promise<void> {
    try {
      if (this.isValid()) {
        this.beforupdate();
        this.sts.showToast("info", "", this.translate("ClientApp.FrontOffice.Inv.SaleFormula.SavingChanges"));
        this.isSaving = true;
        this.isSaved = false;
        this.formulas.forEach((formula) => {
          formula.SaleFormulaDetails = formula.SaleFormulaDetails?.filter((x) => x.State !== RowState.Detached);
          const hasEditAndInsertDetail = formula.SaleFormulaDetails.some((x) => x.State !== RowState.NoChange && !!formula.Id);
          if (hasEditAndInsertDetail) formula.State = RowState.Modify;
          if (formula.Id) {
            formula.SaleFormulaDetails.forEach((x) => {
              x.SaleFormulaId = formula.Id;
            });
            this.addGoods = true;
          }
        });
        const res = await this.httpCommonService.create("SaleFormula/SaveFormulas", this.formulas).pipe(take(1)).toPromise();
        this.saveSuccessHelper(res);
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (error) {
      this.saveFailedHelper(error);
    }
  }

  showHideActions() {
    setTimeout(() => {
      this.addGoods = !!this.headerGrid.dataList.length;
      this.cd.markForCheck();
    }, 0);
  }
}
